module.exports = __webpack_public_path__ + "img/xindachanyeyuan.c03f8617.jpg";